import { MonoStat, Tile } from '@diwata/ironvale'
import type { LakeFeed } from '@/api/feeds'
import { envelopeStatus, UnavailableNote } from './shared'

/** Lore registry health + spring freshness — shallow on purpose; grows later. */
export function LakeTile({ feed }: { feed: LakeFeed }) {
  return (
    <Tile
      title="Lake"
      status={envelopeStatus(feed)}
      asOf={feed.asOf}
      href={feed.link ?? undefined}
      linkLabel="lore"
    >
      {feed.status === 'unavailable' ? (
        <UnavailableNote feed={feed} />
      ) : (
        <>
          {feed.pipelines && (
            <div className="ap-stat-row">
              <MonoStat value={`${feed.pipelines.ok}/${feed.pipelines.total}`} label="springs ok" />
            </div>
          )}
          {feed.pipelines?.attention?.length ? (
            <div className="ap-tile-rows">
              {feed.pipelines.attention.map((p) => (
                <div key={p.source} className="ap-tile-row">
                  <span className="ap-row-name">{p.source}</span>
                  <span className="ap-row-value">{p.status}</span>
                </div>
              ))}
            </div>
          ) : (
            <p className="ap-tile-note">{feed.reason ?? 'all springs current'}</p>
          )}
        </>
      )}
    </Tile>
  )
}
